import { SVGProps } from 'react';

const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="m5.73 11.06.94.94 4-4-4-4-.94.94L8.783 8 5.73 11.06Z" />
    </svg>
);
export default SvgChevronRight;
